import { Component } from '@angular/core';

@Component({
    selector: 'app-task-list',
    templateUrl: './task-list.component.html',
    standalone: false
})
export class TaskListComponent {
  constructor() {
    console.log('[TaskListComponent] constructor');
  }
}
